<template>
  <div id="content1" class="content1">
 	<VAccount class="acount"></VAccount>
 	<div style="height: 116px;"></div>
		<div class="mbxw">
			<div class="mbxspan">
				<el-breadcrumb separator-class="el-icon-arrow-right" class="Mbx">
				  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item>{{Mbx1}}</el-breadcrumb-item>
				  <el-breadcrumb-item>{{Mbx2}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
<!--		<div class="nr bodyFont clearfloat" id="bodyFont" ref="bodyFont" :class="{bodyHeight:contentStatus}">-->
			<div class="nr bodyFont clearfloat" id="bodyFont">
	    <h3 v-text="title" align="center" class="mtitle"></h3>
	    <div class="gongju">
	      <p class="des">作者：{{author}}&emsp;&emsp;更新日期：{{updateTime|datefmt('YYYY-MM-DD')}}&emsp;&emsp;点击量：{{hits}}
	      <a href='javascript:void(0)' class="gj" @click="clickPrinting()" target="_blank">打印本页</a>&nbsp;&nbsp;&nbsp;
	      </p>
	    </div>
	    <div v-html="content" class="nrcontent"></div>
	    <div class="content_url" v-if="filesUrl.length!=0">
	      <span>附 件:</span>
	      <ul>
	        <li v-for="item in filesUrl">
	          <a v-bind:href="item.showUrl" v-bind:title="item.fileTitle"><span v-text="item.fileTitle">等待...</span></a>&emsp;
	          <a v-bind:href="item.downloadUrl" color="#409EFF">[点此下载/预览]</a>
	        </li>
	      </ul>
	    </div>
   </div>
<!--    	<div class="contentToggle" v-if="contentStatus" @click="contentStatus=!contentStatus">阅读全文</div>-->
    <div class="frUrl">
			<VFrUrl></VFrUrl>
		</div>
    <VFooter class="footer"></VFooter>
  </div>
</template>
<script>
import web from "@/assets/js/web.js";
import VAccount from '../subcomponents/account'
import VNav from '../subcomponents/nav'
import VFooter from '../subcomponents/footer'
  export default {
		components: {VAccount,VNav,VFooter},
    name: "content1",
    data() {
      return {
        path: '/detail',    // 内容请求路径
        cfg: {params: {articleId: this.$route.params.id}},    // 内容请求参数,this.$route.params.id 是内部路由传递过来的参数
        articleID: '',
        author: '',
        title: '',
        copyFrom: '',
        updateTime: '',
        content:[],
        hits: 0,
        filesUrl: [],    // 元素：{"fileTitle":"", "showUrl":"", "downloadUrl":""}, ...
        contentStatus:false,  
        curHeight:0,
        bodyHeight:700,
        Mbx1:'',
        Mbx2:'内容详情'
      }
    },
    created() {
      console.log('this.$route.params.id : ', this.$route.params.id);
      this.getData();
      console.log(this.$route.query.Mbx1);
    },
    methods: {
      getData() {
        web.api.get(this.path, this.cfg).then(res=>{
          if(res.status) {
            this.articleID= res.data[0].articleID;
            this.author= res.data[0].author;
            this.title= res.data[0].title;
            this.copyFrom= res.data[0].copyFrom;
            this.updateTime= res.data[0].updateTime;
            this.content= res.data[0].content;
            this.hits= res.data[0].hits;
          }
          else console.log('出错信息:' + res.message);
        }).catch(error=>{console.log(error)});
        this.Mbx1=this.$route.query.Mbx1;
      },
    	contentToggle(){
        this.curHeight=this.$refs.bodyFont.offsetHeight;
        if(this.curHeight>this.bodyHeight){
          this.contentStatus=true;
        }else{
          this.contentStatus=false;
        }
      },
			clickPrinting() {
			        //  找到需要隐藏的DOM节点
			        let head = document.getElementsByClassName('acount')[0];
			        let printBtn = document.getElementsByClassName('nav')[0];
			        let from2 = document.getElementsByClassName('footer')[0];
			
			        //  给对应DOM添加class
			        head.classList.add("printHideCss")
			        printBtn.classList.add("printHideCss")
			        from2.classList.add("printHideCss")
			
			        window.print(); //  调用打印功能
			        window.location.reload(); //  点击取消打印后刷新页面，恢复点击打印按钮之前的原始数据
			}
    },
    mounted(){
       setTimeout(()=>{
          this.contentToggle();
        },100)    	
    }
  }
</script>
<style scoped>
	*{
		list-style: none;
		color:#333
	}
	.nr{
		width:1200px;
		min-height:700px;
		background-color:#fff;
		margin:0 auto;
	}
	.mtitle {
	    border-top: 3px solid #087cd6;
	    font-size: 28px;
	    line-height: 160%;
	    padding: 30px;
	    color:#333;
	}
	.gongju{
		height: 52px;
		border-bottom: 1px dashed #ccc ;
		position:relative;
		top:-20px;
	}
	.des{
		line-height: 52px;
		position:relative;
		left:20px;
		color:#333;
		font-size: 14px;
	}
	.nrcontent{
		width:1160px;
		margin:0 auto;
	}
	.content_url{
		width:1160px;
		margin:0 auto;
	}
	.gj{
		float: right;
		position: relative;
		right:40px;
		padding-right: 20px;
		color:#333;
	}
	.gj img{
		position: relative;
		top:4px;
	}
	.bodyFont{
	    color: #333;
	    text-align: left;
	    line-height:58px;
	    word-break:break-all;
	    word-wrap:break-word;
	    padding-bottom: 30px;
	    height:auto;
	    overflow: hidden;
	    max-height: 100%;
	  }
	  .bodyHeight{
	    height:700px;
	  }
	  .contentToggle{
	  	width:100px;
	  	margin:0 auto;
	  	margin-top:0.5px;
	    height:40px;
	    line-height:40px;
	    text-align: center;
	    color:red;
	    border:1px solid red;
	    border-radius: 5px;
	    margin-bottom:30px;
	  }
	  /*mbx*/
		.mbxw{
			width:1200px;
			height:40px;
			position: relative;
			top:15px;
			margin:0 auto;
		}
		.mbx .el-breadcrumb__item{
			font-size: 17px;
			line-height: 30px;
		}
		.mbxspan{
			position:relative;
			left:20px;
		}
		.printHideCss{
			display: none;
		}
		.frUrl{
		width:1200px;
		height:60px;
		margin-top:10px;
		margin:0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/pub/content.vue